<template>
  <div class="boxbgcolor ioRecord">
    <div class="left content-left">
      <AreaTree
        v-on:handleTreeClick="handleTreeClick"
        :moduleName="moduleName"
      ></AreaTree>
    </div>
    <div class="right content-right">
      <!--左侧上方搜索框-->
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float" @submit.prevent>
          <div v-show="showList" class="form-group">
            <label for="bdate">收费员:</label>
            <el-select
              v-model="search.chargeIds"
              multiple
              clearable
              collapse-tags
              placeholder="请选择"
              onchange="onSelectedChange"
            >
              <el-option
                v-for="item in chargeUserByGroupIdData"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div v-show="showList" class="form-group">
            <label for="bdate">考核时间:</label>
            <el-date-picker
              :clearable="false"
              value-format="yyyy-MM"
              v-model="search.yearMonth"
              type="month"
            ></el-date-picker>
          </div>
          <div v-show="showList" class="form-group">
            <span class="search_btn">
              <el-button
               size="small"
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
                :loading="loading"
              >
                查询
              </el-button>
            </span>
            <span class="download_btn">
              <el-button
                @click="downloadExcel"
                type="button"
                class="btn btn-primary"
                :loading="downloading"
              >
                导出EXCEl
              </el-button>
            </span>
          </div>
        </form>
      </div>
      <template>
        <div class="list-right">
          <el-table
            ref="table"
            border
            :data="tableListData"
            height="100%"
            width="100%"
            :header-cell-style="tableHeaderStyle"
            :cell-style="styleObj"
            v-loading="loading"
            show-summary
            :summary-method="getSummaries"
          >
            <el-table-column
              show-overflow-tooltip
              label="考核年月"
              prop="yearMonth"
            ></el-table-column>

            <el-table-column
              show-overflow-tooltip
              label="路段名称"
              prop="parkingName"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="收费员"
              prop="chargeName"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="车位数"
              prop="spaceCount"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="基本工资"
              prop="basicSalary"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="保底工资"
              prop="guaranteedSalary"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="应收笔数"
              prop="shouldTotal"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="应收额"
              prop="shouldMoney"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="实收额"
              prop="actualMoney"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="补缴额"
              prop="suppleMoney"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="欠费额"
              prop="arrearsMoney"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="实时笔数"
              prop="actualTotal"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="未登记数"
              prop="noOrderCount"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="手工离场数"
              prop="manualCount"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="每月任务额"
              prop="monthRecoverMoney"
            ></el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="每月停车券任务数量"
              prop="monthCouponCount"
            ></el-table-column>
          </el-table>
        </div>
      </template>

      <Page
        v-on:pagination="receivePaginationData"
        v-bind:pageObj="pageObj"
      ></Page>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import {
  queryChargeUserMonthStatistics,
  requestChargeUserByGroupId,
} from "@/api/url";
import AreaTree from "@/page/commons/areaTree";
import Page from "@/page/commons/page";
// import Refresh from '../commons/refresh.vue';
import dayjs from "dayjs";
export default {
  data() {
    return {
      treeData: {
        groupId: "",
      },
      //根据集团Id获取收费员
      chargeUserByGroupIdData: [],
      moduleName: "property",
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      switchValue: "list",
      showList: true,
      showChart: false,
      showTimeDay: true,
      showTimeMonth: false,
      search: {
        pageSize: 10,
        pageNumber: 1,
        yearMonth: "",

        chargeIds: [],
      },
      value4: "",
      tableListData: [],
      tableListDataTitle: [],

      pageObj: {},
      loading: false,
      totalMap: {},
      downloading: false,
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      if (!this.treeData.groupId) {
        this.$message({
          type: "warning",
          message: "请选择集团！",
        });
        return;
      }
      this.tableList(this.search.pageNumber);
    },
    //点击树的节点展示相应数据
    handleTreeClick: function(node, data) {
      this.search.chargeIds = [];
      if (node.type == "group") {
        this.treeData.groupId = node.id;
        this.search.pageNumber = 1;
        this.chargeUserByGroupId();
        this.tableList(this.search.pageNumber);
      } else {
        this.treeData.groupId = "";
        this.tableListData = [];
        var pageObj = {
          curIndex: 1,
          rowsCount: 0,
        };
        this.pageObj = { ...pageObj };
        // this.getPage(pageObj);
        //  this.$message({
        // 	message: '请选择车场！',
        // 	type: 'warning'
        // 	});
      }
    },
    tableList: function(curPage) {
      var _this = this;
      this.loading = true;
      this.$get(queryChargeUserMonthStatistics(), {
        page: curPage,
        limit: this.search.pageSize,
        groupId: this.treeData.groupId,
        yearMonth: dayjs(this.search.yearMonth).format("YYYY-MM"),
        chargeIds: this.search?.chargeIds?.join(",") ?? "",
      })
        .then((data) => {
          if (data.status != 200) return _this.$layer.msg(data.message);
          //翻页
          var pageObj = {
            curIndex: data.data.offset,
            rowsCount: data.data.total,
          };
          this.pageObj = { ...pageObj };
          // _this.getPage(pageObj);
          _this.tableListData = data.data.rows;
          this.totalMap = data.data.totalMap;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    searchList: function() {
      if (this.treeData.groupId) {
        this.search.pageNumber = 1;
        this.tableList(this.search.pageNumber);
      } else {
        this.$message({
          message: "请选择集团！",
          type: "warning",
        });
      }
    },

    downloadExcel() {
      if (!this.treeData.groupId) {
        this.$message({
          type: "warning",
          message: "请选择集团",
        });
        return;
      }
      this.downloading = true;
      this.$downloadFileRequest(
        "/api/parking/chargeUser/queryChargeUserMonthStatisticsExport",
        {
          groupId: this.treeData.groupId,
          yearMonth: dayjs(this.search.yearMonth).format("YYYY-MM"),
          chargeIds: this.search?.chargeIds?.join(",") ?? "",
        },
        "收费员月度考核"
      ).finally(() => {
        this.downloading = false;
      });
    },
    chargeUserByGroupId() {
      this.$get(requestChargeUserByGroupId(), {
        groupId: this.treeData.groupId,
      }).then((data) => {
        if (data.status != 200) return this.$layer.msg(data.message);
        this.chargeUserByGroupIdData = data.data;
      });
    },
    onSelectedChange(val) {
      console.log("selected charge=>", val);
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总计";
        }
        if (index === 3) {
          sums[index] = this.totalMap?.totalSpaceCount ?? 0;
        }
        if (index === 4) {
          sums[index] = this.totalMap?.totalBasicSalary ?? 0;
        }
        if (index === 5) {
          sums[index] = this.totalMap?.totalGuaranteedSalary ?? 0;
        }
        if (index === 6) {
          sums[index] = this.totalMap?.shouldTotal ?? 0;
        }

        if (index === 7) {
          sums[index] = this.totalMap?.totalShouldMoney ?? 0;
        }
        if (index === 8) {
          sums[index] = this.totalMap?.totalActualMoney ?? 0;
        }
        if (index === 9) {
          sums[index] = this.totalMap?.totalSuppleMoney ?? 0;
        }
        if (index === 10) {
          sums[index] = this.totalMap?.totalArrearsMoney ?? 0;
        }
        if (index === 11) {
          sums[index] = this.totalMap?.actualTotal ?? 0;
        }

        if (index === 12) {
          sums[index] = this.totalMap?.totalNoOrderCount ?? 0;
        }
        if (index === 13) {
          sums[index] = this.totalMap?.manualCount ?? 0;
        }

        if (index === 14) {
          sums[index] = this.totalMap?.totalMonthRecoverMoney ?? 0;
        }
        if (index === 15) {
          sums[index] = this.totalMap?.totalMonthCouponCount ?? 0;
        }
      });
      return sums;
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
      nodeData: (state) => state.nodeData,
      nod: (state) => state.nod,
    }),
  },
  components: {
    Page,
    AreaTree,
  },

  mounted: function() {
    this.search.yearMonth = new Date();
  },
  watch: {},
};
</script>

<style scoped>
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}
.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: #f9f9fb;
  border-bottom: 10px solid #eff2f7;
}
.searchboxTo {
  background: #f9f9fb;
  border-bottom: 10px solid #eff2f7;
  margin-left: 120px;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
#myChart {
  overflow-x: auto;
}
.form-group .switchGroup {
  margin-left: 50px;
  display: flex;
  align-items: center;
}

.switch-info {
  display: inline-block;
  margin-left: 5px;
}
.show-list {
  height: 500px;
}
.show-date {
  text-align: center;
  height: 26px;
  line-height: 26px;
  background: #f9f9fb;
  font-size: 24px;
  font-weight: bold;
}
</style>
<style>
.ioRecord .el-select {
  width: 150px;
}
.switchGroup .el-input__inner {
  border: 1px solid #67c23a;
  border-radius: 4px;
}
</style>
